var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManArmBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "98px",
    viewBox: "0 0 51 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ManArmBack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ManArmBack",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.31185298,0 C9.31185298,0 0.368420936,34.7398855 2.26366571,45.815693 C4.15891049,56.8915005 23.9262742,51.8595753 23.9262742,51.8595753 L24,1.37315733 L9.31185298,0",
    id: "Fill-109",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,49.3798372 L24.1579562,94.2640387 C28.4599203,105.704623 56.5538872,88.4230528 50.0190037,75.3056688 C49.6068033,74.4791892 24.1559455,26 24.1559455,26 C24.1559455,26 1.60154914,33.0747451 0,49.3798372",
    id: "Fill-110",
    fill: "#B1BCCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManArmBack);
export default __webpack_public_path__ + "static/media/ManArmBack.ddb1750e7b55e334fcb854437d22b9f1.svg";
export { ForwardRef as ReactComponent };